import { Inject, Injectable, forwardRef} from '@angular/core';
import { Http, Response, RequestOptions, Headers } from '@angular/http';

import  { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/toPromise';

import { HttpClient } from './http-client.service';
import { CachedCallService } from './cached-call.service';

import { TranslationKeyDto } from '../../entities/translation-key-dto';

import { Settings } from '../../settings';
import { ODataBuilder } from '../../utility/odata/odata-builder';
import { ODataComparer } from '../../utility/odata/odata-comparer';

@Injectable()
export class TranslationKeyDtoService {
  private readonly headers:Headers = new Headers({ 'Content-Type': 'application/json' });
  private readonly options:RequestOptions = new RequestOptions({ headers: this.headers });

  private static readonly translationKeysBaseUrl:string = `${Settings.apiUrl}/v1/TranslationKeys`;

  protected cachedCallService:CachedCallService = new CachedCallService();

  constructor(@Inject(forwardRef(() => HttpClient)) private http:HttpClient) { }

  getTranslationKeyDtos(searchTerm:string, onlyWithMissingTranslation:boolean, missingLanguageId:number, top:number, skip:number): Promise<any> {

    let translationKeyUrl:string = `${TranslationKeyDtoService.translationKeysBaseUrl}/RCC.GetTranslationKeyDtos(SearchTerm='${searchTerm}',OnlyWithMissingTranslation=${onlyWithMissingTranslation},MissingLanguageId=${missingLanguageId})/?$top=${top}&$skip=${skip}&$orderby=Name&$count=true`;

    return this.http.get(translationKeyUrl)
      .toPromise()
      .then(response => response.json());

  }

  getTranslationCountForTranslationKeyDtos(searchTerm:string, onlyWithMissingTranslation:boolean, missingLanguageId:number): Promise<any> {
    
        let translationKeyUrl:string = `${TranslationKeyDtoService.translationKeysBaseUrl}/RCC.GetTranslationCountForTranslationKeyDtos(SearchTerm='${searchTerm}',OnlyWithMissingTranslation=${onlyWithMissingTranslation},MissingLanguageId=${missingLanguageId})/`;
    
        return this.http.get(translationKeyUrl)
          .toPromise()
          .then(response => response.json());
    
      }

  patchEntityForTranslationKey(entityType:string, entityIdValue:string, entityObj:any): Promise<null> {

    let url: string = `${Settings.apiUrl}/v1/${entityType}(${entityIdValue})`;
    
    return this.http.patch(url, JSON.stringify(entityObj), this.options)
      .toPromise()
      .then(response => response);
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/ng-router-loader?{"loader":"async-system","genDir":"compiled","aot":false}!./src/app/services/http/translation-key-dto.service.ts